/**
 * @param  {string<ServiceType>} serviceType
 * @param  {ErrorsHandler.handleError} handleError
 */
import ErrorPayload from '../../Errors/Utils/ErrorPayload';

const createServiceErrorType = serviceType => `API_SERVICE_${serviceType.toUpperCase()}`;

const handleServiceError = (serviceType, handleError) =>
    error => handleError(
        new ErrorPayload(
            createServiceErrorType(serviceType),
            error,
        )
    );

export default handleServiceError;
